import { render, staticRenderFns } from "./Sora.vue?vue&type=template&id=0ffa24ee&scoped=true"
import script from "./Sora.vue?vue&type=script&lang=js"
export * from "./Sora.vue?vue&type=script&lang=js"
import style0 from "./Sora.vue?vue&type=style&index=0&id=0ffa24ee&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa24ee",
  null
  
)

export default component.exports